// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".integration-list-grid{display:grid;-webkit-box-align:center;-ms-flex-align:center;align-items:center;grid-template-columns:3fr 1fr 1fr 1.5fr .6fr}", ""]);
// Exports
module.exports = exports;
